import injectSheet from 'react-jss'
import AppFooter from './AppFooter'
import styles from './AppFooter.styles'

export default injectSheet(styles)(AppFooter)
